<template>
<div class="d-flex">
  <v-row no-gutters align="center" class="d-inline-flex">
      <ul class="pagginationTop">
        <li>
          <span class="font-weight-bold primary--text" v-translate>Top</span>
        </li>
        <li class="pagginationTop__icon" >
          <v-btn icon
            :disabled="!previousLink"
            :to="previousLink" style="color: black"
            :active-class="'no-active-shadow'"
            @click.prevent.stop.capture="$emit('loadTop', {$event, link: previousLink})"
          >
            <i class="far fa-chevrons-left"></i>
          </v-btn>
        </li>
        <li
          class="pagginationTop__number ml-1 mr-1"
          v-for="link in topLinks"
        >
          <v-btn :to="link" icon
            :class="[
              link.params.top == currentTop ? 'primary--text' : 'black--text'
            ]"
            :active-class="'no-active-shadow'"
            @click.prevent.stop.capture="$emit('loadTop', {$event, link})"
          >
            {{ link.params.top }}
          </v-btn>
        </li>
        <li class="pagginationTop__icon">
          <v-btn
            :disabled="!nextLink"
            icon :to="nextLink" style="color: black"
            :active-class="'no-active-shadow'"
            @click.prevent.stop.capture="$emit('loadTop', {$event, link: nextLink})"
          >
            <i class="far fa-chevrons-right"></i>
          </v-btn>
        </li>
        <li>
          <span>&nbsp;
            <v-btn
              icon :to="allLink"
              class="font-weight-bold d-inline-flex"
              :class="currentTop ? 'black--text' : 'primary--text'"
              :active-class="'no-active-shadow'"
              @click.prevent.stop.capture="$emit('loadTop', {$event, link: allLink})"
            ><translate>All</translate></v-btn>
          </span>
        </li>
      </ul>
  </v-row>
</div>
</template>

<script>
import ButtonGoogleMap from"@/components/Buttons/ButtonGoogleMap";
export default {
  name: "PaginationRanking",
  components: {ButtonGoogleMap},
  props: {
    currentCountry: {type: Object, default: () => {}},
    currentTop: {type: Number, default: null},
    currentZone: {type: Object, default: () => {}},
  },
  computed: {
    topLinks() {
      const topList = [
        0,10,20,30,40,50,100,
        200,300,400,500,1000
      ]
      const topLinks = []
      let name = 'ranking-worldwide'
      if(this.currentCountry) {
        name = 'ranking-country'
      } else if(this.currentZone) {
        name = 'ranking-zone'
      }
      let totalCourse = 999999;
      const params = {}
      if(this.currentCountry) {
        totalCourse = this.currentCountry.totalCourse
        params.country = this.currentCountry.slug
        params.countryName = this.currentCountry.slug
      } else if (this.currentZone) {
        totalCourse = this.currentZone.totalCourse
        params.zone = this.currentZone.slug
        params.zoneName = this.currentZone.slug
      }
      topList.forEach((top, index) => {
        if (totalCourse > top) {
          if(topList[index + 1]) {
            params.top = topList[index + 1]
            const linkParams = Object.assign({}, params)
            topLinks.push({name, params: linkParams})
          }
        }
      })
      return topLinks
    },
    previousLink() {
      let linkIndex = -1
      this.topLinks.forEach((link, index) => {
        if(link.params.top == this.currentTop) {
          linkIndex = index
        }
      })
      if(linkIndex === -1 || !this.topLinks[linkIndex - 1])
        return null
      return this.topLinks[linkIndex - 1]
    },
    nextLink() {
      let linkIndex = -1
      this.topLinks.forEach((link, index) => {
        if(link.params.top == this.currentTop) {
          linkIndex = index
        }
      })
      if(linkIndex === -1 || !this.topLinks[linkIndex + 1])
        return null
      return this.topLinks[linkIndex + 1]
    },
    allLink() {
      if(this.currentCountry) {
        return {
          name: 'ranking-country-all',
          params: {
            country: this.currentCountry.slug
          }
        }
      } else if(this.currentZone) {
        return {
          name: 'ranking-zone-all',
          params: {
            zone: this.currentZone.slug
          }
        }
      }
      return {
        name: 'ranking-worldwide-all'
      }
    }
  }
};
</script>